const flagUk = require("../resources/images/flags/uk.svg");
const flagRu = require("../resources/images/flags/ru.svg");
const flagKa = require("../resources/images/flags/ka.svg");
const flagTr = require("../resources/images/flags/tr.svg");
const flagUa = require("../resources/images/flags/ua.svg");
const flagDe = require("../resources/images/flags/de.svg");
const flagEs = require("../resources/images/flags/es.svg");
const flagFr = require("../resources/images/flags/fr.svg");
const flagIt = require("../resources/images/flags/it.svg");
const flagPl = require("../resources/images/flags/pl.svg");
const flagPt = require("../resources/images/flags/pt.svg");

export interface LanguageOptionType {
    label?: string;
    flag?: any;
    code?: string
}

const languages = {
    en: {
        label: "English",
        flag: flagUk.default,
    },
    es: {
        label: "Español",
        flag: flagEs.default,
    },
    fr: {
        label: "Français",
        flag: flagFr.default,
    },
    pt: {
        label: "Português",
        flag: flagPt.default,
    },
    de: {
        label: "Deutsch",
        flag: flagDe.default,
    },
    ru: {
        label: "Русский",
        flag: flagRu.default,
    },
    tr: {
        label: "Türkçe",
        flag: flagTr.default,
    },
    it: {
        label: "Italiano",
        flag: flagIt.default,
    },
    pl: {
        label: "Polski",
        flag: flagPl.default,
    },
    ua: {
        label: "Українська",
        flag: flagUa.default,
        code: "UA"
    },
    ka: {
        label: "ქართული",
        flag: flagKa.default,
    },
}
export const widgetLanguages = {
    en: {
        label: "English",
        flag: flagUk.default,
        code: "EN"
    },
    ru: {
        label: "Русский",
        flag: flagRu.default,
        code: "RU"
    },
    ka: {
        label: "ქართული",
        flag: flagKa.default,
        code: "GE"
    },
    ua: {
        label: "Українська",
        flag: flagUa.default,
        code: "UA"
    },
    tr: {
        label: "Türkçe",
        flag: flagTr.default,
        code: "TR"
    },
    de: {
        label: "Deutsch",
        flag: flagDe.default,
        code: "DE"
    },
    es: {
        label: "Español",
        flag: flagEs.default,
        code: "ES"
    },
    fr: {
        label: "Français",
        flag: flagFr.default,
        code: "FR"
    },
    it: {
        label: "Italiano",
        flag: flagIt.default,
        code: "IT"
    },
    pl: {
        label: "Polski",
        flag: flagUk.default,
        code: "PL"
    },
    pt: {
        label: "Português",
        flag: flagUk.default,
        code: "PT"
    },
}

export default languages
